import { useTranslate } from 'hooks/useTranslate';
import { FC, ReactElement } from 'react';

import Page from 'modules/_shared/components/Pages/Page';
import Button from 'modules/_shared/components/Buttons';
import GoBackButton from 'modules/_shared/components/Buttons/GoBackButton';
import CustomLoading from 'modules/_shared/components/CustomLoading';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';

import { formatNumber } from 'utils/formats';

import ShareDetailsPageBody from './components/ShareDetailsPageBody';
import { useShareDetailsPage } from './context/ShareDetailsPageContext';

import './ShareDetails.scss';

const ShareDetails: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useShareDetailsPage();

  const pageActions: ReactElement[] = [
    <GoBackButton key="go-back" />,
    <Button
      onClick={actions.handleEditShare}
      text={t('Edit')}
      disabled={data.isReadOnly}
    />,
    <Button onClick={() => {}} text={t('Transfer')} disabled />,
  ];

  return (
    <Page>
      <PageListHeader
        subTitle={t('ShareDetails')}
        description={
          // eslint-disable-next-line react/jsx-wrap-multilines
          <ul className="list-inline">
            <li>
              {t('Range')}:&nbsp;
              <span className="text-base fw-bold">
                {`${formatNumber(data.from)} - ${formatNumber(data.to)}`}
              </span>
            </li>
          </ul>
        }
        actions={data.isAdmin && !data.isReadOnly ? pageActions : []}
      />

      <ShareDetailsPageBody />

      {data.isLoading && <CustomLoading />}
    </Page>
  );
};

export default ShareDetails;
